"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = __importDefault(require("../../../../../user/components/UserLinkTable/ToolBar/FilterSortPanel/styles"));
var CheckIcon_1 = __importDefault(require("../../../../../user/components/UserLinkTable/ToolBar/FilterSortPanel/widgets/CheckIcon"));
var SortButton = function (_a) {
    var columnLabel = _a.columnLabel, isSelected = _a.isSelected, onClick = _a.onClick;
    var classes = styles_1.default();
    return (react_1.default.createElement(core_1.Button, { classes: { root: classes.sortButtonRoot, label: classes.sortButtonLabel }, className: isSelected ? classes.sortButtonSelected : classes.sortButton, fullWidth: true, onClick: function () { return onClick(); } },
        react_1.default.createElement(core_1.Typography, { variant: "body2", className: classes.columnLabel }, columnLabel),
        isSelected && react_1.default.createElement(CheckIcon_1.default, { className: classes.checkIcon })));
};
exports.default = SortButton;
